import Styles from './BrandProfileWebsite.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'blaze-ui/Heading/Heading'

export const BuildYourPlan = () => {
  return (
    <div className={Styles.buildYourPlanContainer}>
      <div className={Styles.brandPlanStep}>
        <Text variant="smallList" color="var(--dark-40)">
          Step 1:
        </Text>
        <div className={Styles.content}>
          <Heading level={4}>📝 Brand Profile</Heading>
          <Text variant="secondary" color="var(--dark-60)">
            We learn your brand voice and style.
          </Text>
        </div>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.brandPlanStep}>
        <Text variant="smallList" color="var(--dark-40)">
          Step 2:
        </Text>
        <div className={Styles.content}>
          <Heading level={4}>🎨 Brand Identity</Heading>
          <Text variant="secondary" color="var(--dark-60)">
            We capture your visual identity.
          </Text>
        </div>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.brandPlanStep}>
        <Text variant="smallList" color="var(--dark-40)">
          Step 3:
        </Text>
        <div className={Styles.content}>
          <Heading level={4}>🧭 Strategy</Heading>
          <Text variant="secondary" color="var(--dark-60)">
            We plan your marketing strategy.
          </Text>
        </div>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.brandPlanStep}>
        <Text variant="smallList" color="var(--green-50)">
          Result
        </Text>
        <div className={Styles.content}>
          <Heading level={4}>🗓 Content Calendar</Heading>
          <Text variant="secondary" color="var(--dark-60)">
            Your autopilot gets to work.
          </Text>
        </div>
      </div>
    </div>
  )
}
